import React, { useState } from 'react';
import { Box, Button, Paper, Stack, TextField, Typography } from '@mui/material';
import '../css/keywordImageEventSite.css';

type KeywordPreset = {
  label: string;
  keywords: string[];
  imagePath: string;
  caption: string;
};

const KEYWORD_PRESETS: KeywordPreset[] = [
  {
    label: 'テスト',
    keywords: ['テスト'],
    imagePath: '/image/takara.jpeg',
    caption: 'お宝画像',
  },
];

const normalize = (text: string): string => text.trim().toLowerCase();

const hashKeyword = (keyword: string): number => {
  let hash = 0;
  for (let i = 0; i < keyword.length; i += 1) {
    hash = (hash << 5) - hash + keyword.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

const selectImageByKeyword = (rawKeyword: string): KeywordPreset => {
  const keyword = normalize(rawKeyword);
  const exactMatch = KEYWORD_PRESETS.find((preset) =>
    preset.keywords.some((word) => keyword.includes(word))
  );

  if (exactMatch) {
    return exactMatch;
  }

  const index = hashKeyword(keyword || 'default') % KEYWORD_PRESETS.length;
  return KEYWORD_PRESETS[index];
};

const KeywordImageEventSite: React.FC = () => {
  const [keyword, setKeyword] = useState('');
  const [selectedImage, setSelectedImage] = useState<KeywordPreset | null>(null);
  const [searchedKeyword, setSearchedKeyword] = useState('');

  const handleGetImage = () => {
    const picked = selectImageByKeyword(keyword);
    setSelectedImage(picked);
    setSearchedKeyword(keyword.trim());
  };

  return (
    <Box className="keyword-event-root">
      <Box className="keyword-event-bg-orb keyword-event-bg-orb-left" />
      <Box className="keyword-event-bg-orb keyword-event-bg-orb-right" />

      <Paper elevation={0} className="keyword-event-panel">
        <Typography className="keyword-event-title-sub" fontSize={20}>
          もん最強サマー伝説５ 特設サイト
        </Typography>
        <Typography className="keyword-event-subtitle" margin={2}>
          ライブ中に発表されたキーワードを入力して、お宝をゲット！
        </Typography>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <TextField
            fullWidth
            label="キーワード"
            placeholder="キーワードを入力"
            value={keyword}
            onChange={(event) => setKeyword(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                handleGetImage();
              }
            }}
          />
          <Button
            variant="contained"
            className="keyword-event-button"
            onClick={handleGetImage}
            disabled={!keyword.trim()}
          >
            お宝をゲット
          </Button>
        </Stack>

        {selectedImage && (
          <Box className="keyword-result-wrap">
            <Paper elevation={0} className="keyword-image-card">
              <img src={selectedImage.imagePath} alt={selectedImage.caption} className="keyword-image" />
            </Paper>
            <Button
              component="a"
              href={selectedImage.imagePath}
              download
              variant="outlined"
              className="keyword-download-button"
            >
              ダウンロード
            </Button>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default KeywordImageEventSite;